import { awIntegrationsApi } from '../Base';
import { PortfolioPerformancePayload, PortfolioPerformanceResponse } from './types';

export function postRetrievePortfolioPerformance(payload: PortfolioPerformancePayload) {
  const path = `/partners/performance/v1/portfolioPerformances:retrieve`;
  return awIntegrationsApi.post<PortfolioPerformanceResponse>(path, payload);
}
